import { InjectionToken } from '@angular/core';
import { FlywireGatewayV2Service, PaymentGatewayService } from '../services';

export const PAYMENT_GATEWAY_SERVICE = new InjectionToken<PaymentGatewayService>('PAYMENT_GATEWAY_SERVICE');
export const PAYMENT_GATEWAY_V2_SERVICE = new InjectionToken<FlywireGatewayV2Service>('PAYMENT_GATEWAY_V2_SERVICE');
